import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        {/* Header */}
        <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors mb-8">
          <ArrowLeft size={18} />
          Torna alla Home
        </Link>

        <h1 className="text-4xl font-bold mb-2">Termini di Servizio</h1>
        <p className="text-slate-400 mb-12">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

        <div className="space-y-8 text-slate-300">
          {/* 1. Accettazione */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Accettazione dei Termini</h2>
            <p className="leading-relaxed">
              Accedendo e utilizzando BudgetAI ("Servizio"), accetti di essere vincolato da questi Termini di Servizio. Se non accetti, non utilizzare il Servizio.
            </p>
          </section>

          {/* 2. Descrizione del Servizio */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Descrizione del Servizio</h2>
            <p className="leading-relaxed">
              BudgetAI è una piattaforma web per il tracciamento delle spese personali, l'analisi finanziaria e la gestione del reddito. Il Servizio include:
            </p>
            <ul className="space-y-2 ml-4 list-disc list-inside mt-3">
              <li>Tracciamento spese e categorizzazione (gratuito e con AI su Premium)</li>
              <li>Importazione e estrazione dati da buste paga</li>
              <li>Gestione spese ricorrenti e tracciamento entrate</li>
              <li>Analitiche e report personali</li>
              <li>Accesso fornito su base di sottoscrizione (Gratuito, Premium Monthly, Premium Annual)</li>
            </ul>
          </section>

          {/* 3. Account e Autenticazione */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Account e Autenticazione</h2>
            
            <h3 className="text-xl font-semibold text-white mb-2">3.1 Registrazione</h3>
            <p className="leading-relaxed">
              Sei responsabile di mantenere la riservatezza della tua password e dell'account. Accetti di fornire informazioni accurate durante la registrazione e di notificarci immediatamente di qualsiasi uso non autorizzato.
            </p>

            <h3 className="text-xl font-semibold text-white mb-2 mt-4">3.2 Termini di Prova</h3>
            <ul className="space-y-2 ml-4 list-disc list-inside">
              <li>Piano Premium: 7 giorni di prova gratuita per i nuovi utenti</li>
              <li>La prova termina automaticamente; ti addebiteremo se non la annulli prima</li>
              <li>I bonus referral (+7 giorni) si sommano al periodo di prova/piano attuale</li>
            </ul>
          </section>

          {/* 4. Pagamenti e Canone */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Pagamenti e Abbonamento</h2>
            
            <h3 className="text-xl font-semibold text-white mb-2">4.1 Tariffe</h3>
            <ul className="space-y-2 ml-4 list-disc list-inside">
              <li><strong>Gratuito:</strong> €0/mese, sempre disponibile</li>
              <li><strong>Premium Monthly:</strong> €5/mese (rinnovamento automatico)</li>
              <li><strong>Premium Annual:</strong> €40/anno (rinnovamento automatico)</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mb-2 mt-4">4.2 Elaborazione Pagamenti</h3>
            <p className="leading-relaxed">
              I pagamenti sono elaborati da Stripe. Non conserviamo informazioni sulla carta di credito; Stripe è il custode della tua informazione di pagamento.
            </p>

            <h3 className="text-xl font-semibold text-white mb-2 mt-4">4.3 Rinnovamento Automatico</h3>
            <p className="leading-relaxed">
              Gli abbonamenti si rinnovano automaticamente al termine del periodo. Puoi cancellare in qualsiasi momento dal tuo account o tramite il Stripe Customer Portal. Nessuna penalità per cancellazione anticipata.
            </p>

            <h3 className="text-xl font-semibold text-white mb-2 mt-4">4.4 Rimborsi</h3>
            <p className="leading-relaxed">
              Offriamo rimborsi a discrezione per entro 14 giorni dall'abbonamento se non sei soddisfatto. Contattaci a billing@budgetai.app per richieste.
            </p>
          </section>

          {/* 5. Licenza di Utilizzo */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Licenza di Utilizzo</h2>
            <p className="leading-relaxed mb-3">
              Ti concediamo una licenza limitata, non esclusiva, non trasferibile per accedere e utilizzare il Servizio per scopi personali.
            </p>
            <p className="leading-relaxed mb-3">
              <strong>Non puoi:</strong>
            </p>
            <ul className="space-y-2 ml-4 list-disc list-inside">
              <li>Modificare, copiare, o distribuire il Servizio</li>
              <li>Reverse-engineering, decompilare o accedere al codice sorgente</li>
              <li>Utilizzare il Servizio per spam, frode, o scopi illegali</li>
              <li>Accedere al Servizio tramite bot automatizzati (senza permesso)</li>
              <li>Condividere il tuo account con altri utenti</li>
            </ul>
          </section>

          {/* 6. Responsabilità Contenuti Utente */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Contenuti e Dati dell'Utente</h2>
            
            <h3 className="text-xl font-semibold text-white mb-2">6.1 Proprietà</h3>
            <p className="leading-relaxed">
              Mantieni la piena proprietà di tutti i dati che carichi nel Servizio (spese, entrate, buste paga, ecc.). Ci concedi una licenza per memorizzarli e elaborarli per fornirti il Servizio.
            </p>

            <h3 className="text-xl font-semibold text-white mb-2 mt-4">6.2 Responsabilità</h3>
            <p className="leading-relaxed">
              Sei responsabile della legalità e accuratezza dei contenuti che carica. Non caricare dati altrui, malware, o contenuti illegali. BudgetAI non memorizza o monopolizza i tuoi dati finanziari: rimangono tuoi per esportare, eliminare, o migrare in qualsiasi momento.
            </p>

            <h3 className="text-xl font-semibold text-white mb-2 mt-4">6.3 Cancellazione Account</h3>
            <p className="leading-relaxed">
              Puoi cancellare il tuo account in qualsiasi momento dal Dashboard. Tutti i dati personali verranno eliminati in modo permanente (backup conservati per 30 giorni solo per disaster recovery, poi cancellati).
            </p>
          </section>

          {/* 7. Disclaimer di Responsabilità */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Disclaimer di Responsabilità</h2>
            <p className="leading-relaxed mb-3">
              <strong>Il Servizio è fornito "così com'è".</strong>
            </p>
            <ul className="space-y-2 ml-4 list-disc list-inside">
              <li>BudgetAI non è consulente finanziario. I dati forniti sono per scopi informativi e non costituiscono consiglio finanziario.</li>
              <li>Le categorizzazioni AI possono contenere errori. Verifica sempre i tuoi dati prima di decisioni finanziarie.</li>
              <li>Non garantiamo continuità del Servizio. Malfunzionamenti, interruzioni, o perdite di dati dovute a fattori al di fuori del nostro controllo non sono responsabilità nostra (salvo non dovuti a nostra negligenza).</li>
              <li>Garantiamo sicurezza ragionevole, ma nessun sistema è 100% sicuro. Non siamo responsabili di accessi non autorizzati dovuti a debolezze nell'autenticazione dell'utente.</li>
            </ul>
          </section>

          {/* 8. Limitazione Responsabilità */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Limitazione di Responsabilità</h2>
            <p className="leading-relaxed">
              NELLA MISURA MASSIMA CONSENTITA DALLA LEGGE, BUDGETAI NON SARÀ RESPONSABILE PER DANNI INDIRETTI, INCIDENTALI, SPECIALI, CONSEQUENZIALI O PUNITIVI, INCLUSA PERDITA DI PROFITTI, DATI O USO, ANCHE SE AVVISATO DELLA POSSIBILITÀ DI TALI DANNI.
            </p>
            <p className="leading-relaxed mt-3">
              LA NOSTRA RESPONSABILITÀ TOTALE NON SUPERA L'IMPORTO CHE HAI PAGATO NEL PERIODO DI 12 MESI PRECEDENTE (O €50 SE NON HAI PAGATO NULLA).
            </p>
          </section>

          {/* 9. Indemnificazione */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Indennizzo</h2>
            <p className="leading-relaxed">
              Accetti di indennizzare e proteggere BudgetAI, i suoi fondatori e dipendenti da qualsiasi reclamo, danno, o spesa derivante dall'uso illecito del Servizio, dalla violazione di questi Termini, o dalla violazione dei diritti altrui.
            </p>
          </section>

          {/* 10. Sospensione e Terminazione */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Sospensione e Terminazione</h2>
            <p className="leading-relaxed mb-3">
              Possiamo sospendere o terminare il tuo account se:
            </p>
            <ul className="space-y-2 ml-4 list-disc list-inside">
              <li>Violi questi Termini</li>
              <li>Utilizzi il Servizio per scopi illegali o dannosi</li>
              <li>Non paghi i canoni dovuti dopo 30 giorni di avviso</li>
              <li>Abbandoni l'account per oltre 12 mesi inattivi</li>
            </ul>
          </section>

          {/* 11. Link Esterni */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Link Esterni</h2>
            <p className="leading-relaxed">
              Il servizio può contenere link a siti web di terze parti. Non siamo responsabili del contenuto, accuratezza o pratica di privacy di siti esterni. L'accesso a link esterni è a tuo rischio.
            </p>
          </section>

          {/* 12. Modifiche ai Termini */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">12. Modifiche a Questi Termini</h2>
            <p className="leading-relaxed">
              Potremmo aggiornare questi Termini. Ti notificheremo via email di modifiche significative. L'uso continuato del Servizio dopo la notifica implica accettazione della versione aggiornata.
            </p>
          </section>

          {/* 13. Legge Applicabile */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">13. Legge Applicabile</h2>
            <p className="leading-relaxed">
              Questi Termini sono governati dalla legge italiana (se applicabile) e dalla GDPR per i dati personali. Qualsiasi controversia sarà risolta prima attraverso negoziazione amichevole, poi tramite arbitrato se necessario.
            </p>
          </section>

          {/* 14. Contatti */}
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">14. Contattaci</h2>
            <p className="leading-relaxed">
              Per domande su questi Termini:
            </p>
            <ul className="space-y-2 ml-4 list-disc list-inside mt-3">
              <li><strong>Email:</strong> support@budgetai.app</li>
              <li><strong>Sito:</strong> https://budgetai.tcdev.xyz</li>
            </ul>
          </section>

          <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-6 mt-8">
            <p className="text-sm">
              <strong>Interpretazione:</strong> Se un tribunale ritenesse una disposizione di questi Termini non esecutiva, quella disposizione sarà modificata per renderla esecutiva mantenendone l'intento, oppure rimossa se non modificabile. Le disposizioni rimanenti rimangono in vigore.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-slate-800 mt-12 pt-8 text-center text-sm text-slate-500">
          <p>© {new Date().getFullYear()} BudgetAI. Tutti i diritti riservati.</p>
        </div>
      </div>
    </div>
  );
}
